import i18n from 'locales/i18n'
import Validator from 'services/data-validator'

const newPasswordValidator = values => {
  const rules = {
    password: [
      'isRequired',
      ['minLength', { count: 8 }],
      'containsNumber',
      'containsCapital'
    ],
    password_confirmation: ['isRequired', ['isEqualTo', { field: 'password', fieldName: i18n.t('account.password_lower') }]]
  }

  return new Validator(values, rules).getErrors()
}

export default newPasswordValidator
